module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAJVJREFUOBHdUkEOgDAI2/z/d+Zj9DGMxiyZJMCcSoxcBEtrBVL6ehDR9opHFqZeeOmLJ3NTmE0UODGiaGayBuA9BC0cWObAE70tR206RsNs/E94dUahLs/hjcNy0TEz5q96dwtjfaijON0xGOM/f3S22wW35UBiRnHVrdUf5ti7W2lSXZ5snK7l4sNGMe2Yifsd8jC3AqPBehudz2xqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Align/layout_AlignRight_normal.png
// module id = 309
// module chunks = 0